export default __webpack_public_path__ + "static/media/wegovy-innercap-remove.5df3a028.mp4";